import React from 'react'

import Separator from '../../../../../components/pdf/Separator'
import View from '../../../../../components/pdf/View'
import { Bullets, Paragraph, SectionHeading } from './_shared/Prose'

/**
 * Seção 2 - Introdução. Texto literal do modelo aprovado por Julia Buzzo ("Modelo PGR
 * 2026 - Banco Bradesco_Varejo"). Substitui o placeholder institucional anterior
 * (arquivo era `02.ObjetivoSection.js` — número/título haviam sido assumidos; o
 * conteúdo real do Objetivo é a Seção 3, ver `03.ObjetivoSection.js`).
 */
const IntroducaoSection = () => (
  <View id="2">
    <Separator weight={15} />
    <SectionHeading numero={2}>INTRODUÇÃO</SectionHeading>

    <Paragraph>
      O Programa de Gerenciamento de Riscos (PGR) do Banco Bradesco S.A. foi instituído em conformidade com a
      Portaria SEPRT nº 8.873, de 23 de julho de 2021, com vigência a partir de 3 de janeiro de 2022, conforme
      estabelecido na Norma Regulamentadora nº 1 – Disposições Gerais e Gerenciamento de Riscos Ocupacionais. Este
      programa foi recentemente atualizado pela Portaria MTE nº 1.419, de 28 de agosto de 2024, cuja vigência se
      inicia em 26 de maio de 2026, este documento reforça a atualização do Programa de Gerenciamento de Riscos
      (PGR), em especial no que diz respeito à inclusão dos fatores psicossociais como categoria de risco
      ocupacional.
    </Paragraph>

    <Paragraph>
      O PGR integra o sistema de Gerenciamento de Riscos Ocupacionais (GRO) da organização, com o objetivo de
      identificar, avaliar e controlar os riscos inerentes às atividades desenvolvidas nesta dependência. Sua
      finalidade é promover a prevenção e mitigação de danos à saúde e à integridade física dos funcionários,
      conforme previsto no item 1.5.4.4 da NR 01, abrangendo os seguintes tipos de riscos: físicos, químicos,
      biológicos, ergonômicos/psicossociais e acidentes/mecânicos.
    </Paragraph>

    <Paragraph>
      Este documento contempla a análise das condições de segurança e saúde no trabalho da agência bancária em
      questão, cujas atividades são predominantemente administrativas, realizadas em edificações de alvenaria, com
      ambientes climatizados artificialmente e iluminados por fontes naturais e artificiais. As atividades incluem
      também o atendimento presencial ao público, abrangendo clientes e não clientes.
    </Paragraph>

    <Paragraph>
      A implementação do PGR será conduzida por meio da elaboração e análise do Inventário de Riscos Ocupacionais,
      cujas tratativas serão consolidadas em um Plano de Ação. Este plano definirá as medidas de controle, prazos,
      responsáveis e mecanismos de acompanhamento, com base nos diagnósticos realizados em campo.
    </Paragraph>

    <Paragraph>
      A gestão contínua do programa, incluindo a produção de evidências e as atualizações necessárias, será de
      responsabilidade do setor de Recursos Humanos e Segurança Ocupacional do Banco Bradesco S.A., durante todo o
      período de vigência do PGR, estipulado em dois anos.
    </Paragraph>

    <Paragraph>
      As atualizações do programa poderão ocorrer conforme a conclusão das ações previstas, em alinhamento com as
      diretrizes do Plano de Ação. Tais atualizações contarão com a participação de áreas correlatas, como o
      Departamento de Patrimônio e a própria unidade avaliada, podendo resultar na elaboração de um Plano de
      Gerenciamento de Riscos Complementar (PGRC), quando necessário.
    </Paragraph>

    <Paragraph>
      No contexto corporativo do Bradesco, que conta com estruturas complexas, múltiplas unidades e funções
      correlatas ao atendimento ao público, a inclusão dos riscos psicossociais no Inventário de Riscos do PGR se
      torna uma medida essencial de conformidade legal (atualização da NR 01 promovida pela Portaria MTE nº
      1.419/2024) e de valorização da saúde integral dos funcionários.
    </Paragraph>

    <Paragraph>O PGR do Bradesco S.A. permanece articulado com:</Paragraph>
    <Bullets
      items={[
        'A NR-09, no que tange ao reconhecimento e avaliação de riscos relacionados a agentes físicos, químicos e biológicos;',
        'A NR-17 – Ergonomia, com ênfase na avaliação dos aspectos psicofisiológicos, organizacionais e cognitivos das atividades;',
        'O PCMSO (NR-7), integrando dados epidemiológicos, indicadores de absenteísmo e adoecimento relacionados ao trabalho.'
      ]}
    />

    <Paragraph>Para garantir a efetividade do gerenciamento, estão previstas ações como:</Paragraph>
    <Bullets
      items={[
        'Levantamento da percepção de riscos pelos funcionários, utilizando mecanismos como pesquisas internas (com metodologia científica que atende a composição da matriz de Severidade e Probabilidade), escutas ativas, feedbacks estruturados e/ou manifestações da CIPA (Comissão Interna de Prevenção de Acidentes e de Assédio) e canais de denúncia;',
        'Comunicação contínua e clara das medidas de prevenção a partir dos riscos identificados; monitoramento periódico de indicadores e fatores de risco;',
        'Implementação de ações corretivas e de promoção da saúde mental em resposta a situações identificadas nos diagnósticos de riscos psicossociais;',
        'Inclusão das medidas no Plano de Ação de SST, com responsabilidades, prazos e mecanismos de monitoramento.'
      ]}
    />

    <Separator weight={15} />
  </View>
)

export default IntroducaoSection
